// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oweD","toggle":"styles_toggle__1t7DG","preview":"styles_preview__1b575"};